import { TableHeader, TableRow, TableHead, cn } from 'twyne-new.ui';

import ColumnResizer from './ColumnResizer';
import { useTableContext } from './context';
import { useColumnWidth } from './hooks';

export const Header = ({ columns, sticky, fixedFistColumnOnScroll = false, dragStateRef, onMouseMove, stopResizing }) => <>
  <TableHeader className='border-b twy-border-base' sticky={sticky}>
    <TableRow>
      {columns.map((column, index) => <>
        <HeaderItem
          key={index}
          column={column}
          index={index}
          fixedFistColumnOnScroll={fixedFistColumnOnScroll}
          dragStateRef={dragStateRef}
          onMouseMove={onMouseMove}
          stopResizing={stopResizing}
        />
      </>)}
    </TableRow>
  </TableHeader>
</>

const HeaderItem = ({ column, index, fixedFistColumnOnScroll, dragStateRef, onMouseMove, stopResizing }) => {
  const { activeResizeColumn, resizedColumns, columnWidths, setColumnWidths, setActiveResizeColumn, setResizedColumns } = useTableContext()
  const columnWidth = useColumnWidth({ columnIndex: index })
  const canBreakHeaderText = activeResizeColumn === index || resizedColumns.includes(index)

  return <HeaderItemResier
    column={column}
    index={index}
    fixedFistColumnOnScroll={fixedFistColumnOnScroll}
    columnWidth={columnWidth}
    canBreakHeaderText={canBreakHeaderText}
    style={columnWidth}
  >
    <ColumnResizer
      isResizing={activeResizeColumn === index}
      onMouseDown={event => handleStartResize({ columnIndex: index, event, columnWidths, setColumnWidths, setActiveResizeColumn, setResizedColumns, handleMouseMove: onMouseMove, stopResizing, dragStateRef })}
    />
    <span data-header-content className={cn('inline-flex items-center whitespace-nowrap', canBreakHeaderText && 'whitespace-normal break-all')}>
      {!column.text ? '' : typeof column.text === 'string' ? column.text : typeof column.text === 'function' ? column.text('', {}, index) : column.text}
    </span>
  </HeaderItemResier>
}

const HeaderItemResier = ({ children, column, index, fixedFistColumnOnScroll, columnWidth, canBreakHeaderText }) => <>
  <TableHead
    className={cn(
      'relative group capitalize whitespace-nowrap',
      canBreakHeaderText && 'whitespace-normal break-all',
      column.headerClassName,
      fixedFistColumnOnScroll && index === 0 && 'sticky left-0 z-30 twy-bg-base-accent shadow-[1px_0_0_0_theme(colors.gray.300)] dark:shadow-[1px_0_0_0_theme(colors.gray.1200)]',
    )}
    style={columnWidth}
  >
    {children}
  </TableHead>
</>

export const handleStartResize = ({ columnIndex, event, columnWidths, setColumnWidths, setActiveResizeColumn, setResizedColumns, handleMouseMove, stopResizing, dragStateRef }) => {
  event.preventDefault()
  event.stopPropagation()

  const headerElement = event.currentTarget?.parentElement
  const measuredWidth = Math.ceil(headerElement?.getBoundingClientRect?.().width || 0)
  if (Object.keys(columnWidths).length === 0) {
    const cells = headerElement?.parentElement?.querySelectorAll?.('th') || []
    const initialWidths = {}
    cells.forEach((cell, cellIndex) => {
      initialWidths[cellIndex] = Math.ceil(cell.getBoundingClientRect().width || 0)
    })
    setColumnWidths(initialWidths)
  }
  const minWidth = 0
  const startWidth = columnWidths[columnIndex] || measuredWidth || 0

  dragStateRef.current = { columnIndex, startX: event.clientX, startWidth, minWidth }
  setActiveResizeColumn(columnIndex)
  setResizedColumns(columns => columns.includes(columnIndex) ? columns : [...columns, columnIndex])

  document.body.style.cursor = 'col-resize'
  document.body.style.userSelect = 'none'
  window.addEventListener('mousemove', handleMouseMove)
  window.addEventListener('mouseup', stopResizing)
}
